import { useMemo } from "react";
import { isSafari } from "react-device-detect";

const getSafariVersion = () => {
  const versionRegex = /Version\/(\d+(\.\d+)?)/;
  const match = versionRegex.exec(navigator.userAgent);
  return match ? Number(match[1]) : null;
};

const hasSafariVoiceRecordingIssue = () => {
  if (!isSafari) return false;

  const version = getSafariVersion();
  return version !== null && version >= 18.4;
};

export const useBrowserSupportsVoiceRecording = () =>
  useMemo(() => !hasSafariVoiceRecordingIssue(), []);
